const ARIA_LABELS = {
  SUBSCRIBER_PICKER: "Subscriber picker",
  DOMAIN_DROPDOWN: "Domain dropdown",
  SUBSCRIBE_ME_CHECKBOX: "Subscribe me",
  PICKER_SELECTION: "Selected subscribers",
  SUBSCRIBER_REMOVE: "Remove",
  SUBSCRIBER_INFO_CALLOUT: "Subscriber info callout",
  ICON_HINT: "Icon hint",
  SUBSCRIBER_LOADING: "Loading subscribers",
  SUGGESTED_RESULTS: "Suggested results"
};
export {
  ARIA_LABELS
};
//# sourceMappingURL=LoadPickSubscribers.types.js.map
